import { useTranslation } from 'react-i18next';
import { useStep } from '../../../Base/StepContext';

export default function ContainerSizeSelectorHeader() {
  const { t } = useTranslation();
  const { activeStep, totalSteps } = useStep();

  return (
    <div className="mb-2 h-[180px] md:h-[320px] text-center flex flex-col justify-center items-center">
      <div
        className="text-uppercase font-medium text-sm"
        style={{ color: '#BF4B30' }}
      >
        {t('header_current_step', { currentStep: activeStep + 1, totalSteps })}
      </div>
      <h1 className="text-2xl md:text-5xl font-bold">
        {t('choose_size_title')}
      </h1>
      <div className="mt-4 max-w-2xl text-center text-base font-normal hidden md:block">
        {t('choose_size_subtitle')} {t('choose_size_subtitle_part_2')}
      </div>
    </div>
  );
}
